<template>
    <v-card elevation="2" shaped class="ma-1">
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Paramètres du module de Code barre </v-toolbar-title>
      </v-toolbar>
      <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
            <v-tab> Lecture </v-tab>
            <v-tab> Scénario </v-tab>

            <v-tabs-items v-model="tab">
              <v-tab-item>

                <v-row>
                  <v-col class="ma-1">
                    <Select :item="{
                      name: 'type de code barre', value: 'typecode', liste: [{ text: 'Code barre libre', value: 'free' }, { text: 'Formaté sur le système', value: 'formatted' }],
                      defaultprops: { show: true }
                    }" :change="(item,value) => setScanParam('typecode', value['value'])"
                      :valField="displays.params.typecode" />

                    <SwitchC
                    :item="{name: 'Scanner avec la caméra',value: 'camera',
                    defaultprops:{ show: true, column: false }}"
                    :change="(item,model)=> { displays.params.camera = model; $emit('recepVal',displays); }"
                    :valField="displays.params.camera"
                    />
                    <v-select :value="displays.params.scanmode || 'individual'"
                      :items="[{text:'Individuel (scénario interactif)',value:'individual'}, {text:'Rafale (sans interaction)',value:'burst'}]"
                      label="Mode de scan" @change="setScanParam('scanmode', $event)" />
                    <v-select :value="displays.params.formats || ['CODE_128']" :items="barcodeFormats"
                      multiple chips label="Formats de codes autorisés"
                      hint="Sélectionnez seulement les formats utiles pour accélérer la détection. Une sélection vide rétablit Code 128."
                      persistent-hint @change="setScanParam('formats', $event.length ? $event : ['CODE_128'])" />
                    <v-alert v-if="displays.params.scanmode === 'burst'" type="info" text class="mt-3">
                      La rafale traite les codes dans l'ordre, en arrière-plan. Le scénario doit être sans confirmation, saisie, navigation ou autre interaction.
                    </v-alert>
                    
                    <SwitchC
                    :item="{name: 'Insertion par fichier CSV',value: 'initfile',
                    defaultprops:{ show: true, column: false }}"
                    :change="(item,model,selectedKey)=> { displays.params.initfile = model; $emit('recepVal',displays); }"
                    :valField="displays.params.initfile"
                    /> 

                    <div v-if="displays.params.initfile">
                    <TextField
                    :item="{ name: 'Texte affiché pour l\'utilisateur', value: 'mentionforfile' ,defaultprops:{ show: true }}"
                    :valField="displays.params.mentionforfile"
                    :keyup="(item,model,selectedKey)=> { displays.params.mentionforfile = model; $emit('recepVal',displays); }"
                    /> 

                    <ArrayTable 
                  :item="{otherparams:{arrayTable:[{type:'select',key:'champ',name:'Clé de la table',ArrayValue:allFields}]},
                  defaultprops:{show:true,tableDraggable:true,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'Ajouter un champ'}}"
                  :valField="displays.params.parserelationfile"
                  :change="(item,model) => {displays.params.parserelationfile = model}"
                  /> 
                    </div>
                  </v-col>
                </v-row>

              </v-tab-item>
  
            <v-tab-item>
              <div v-if="displays.params.typecode=='free'">
                variable pour le code barre : [[scenario||barcode]]
              </div>
              <div v-else>
                Le code complet est disponible dans [[scenario||barcode]].
                Le mode historique « Formaté » ne réalise pas d'extraction automatique de ligne.

              </div>
              <Cventilation :page="page" :table="module.table" :conditions="displays.params.scenario"
                @recepVal="changeScenario"/>
              <p>Format détecté : [[scenario||barcode_format]] ; date serveur : [[scenario||scanned_at]]. Une saisie manuelle utilise le format MANUAL.</p>
            </v-tab-item>
            
            </v-tabs-items>
              </v-tabs>
  
  
  
    </v-card>
  </template>
  
  
  
  <script>
    import { admin } from '../mixins'; 
    import { FORMATS } from './scanSession';
  export default {
    name: "codebarreModule",
    mixins : [admin],
 
  
    data: function () {
      return {
        tab : '',
        tab2 : '',
        allFields : [],
        displays: this.module.displays,
        barcodeFormats: FORMATS.map(value => ({ text: value.replace(/_/g, ' '), value })),

      };
    },
  
    watch: {

    },
  
    methods: {
      setScanParam(key, value) {
        this.$set(this.displays.params, key, value);
        this.$emit('recepVal', this.displays);
      },

      changeScenario(scenario) {
        this.$set(this.displays.params, 'scenario', scenario)
        this.$emit('recepVal', this.displays)
      },

  

  
      getFromAPI() {
        this.getListField({filter:{table:this.module.table}}).then((resp) => {    
    if(Array.isArray(resp)) {
        resp.forEach((field) => {
            this.allFields.push({text:field.displays.name,value:field.cle,default:'value'})
        })
        
    }                                                    
})
      },
  
  
    },
  
    mounted() {
      this.getFromAPI();
    },
  };
  </script>

